export default "__VITE_ASSET__Cj_IQbbE__"